import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";

type AvatarSize = "sm" | "md" | "lg";

export default function AvatarInitials({
  firstName,
  lastName,
  image,
  size,
}: {
  firstName?: string;
  lastName?: string;
  image?: string;
  size?: AvatarSize;
}) {
  const getInitials = (firstName?: string, lastName?: string) => {
    let initials = [firstName, lastName]
      .filter((name) => name)
      .map((name) => name![0])
      .join("");

    return initials.toUpperCase();
  };

  const sizeToClass = (size?: AvatarSize) => {
    switch (size) {
      case "sm":
        return "h-8 w-8";
      case "md":
        return "h-10 w-10";
      case "lg":
        return "h-16 w-16";
      default:
        return "h-10 w-10";
    }
  };

  return (
    <Avatar className={sizeToClass(size)}>
      <AvatarImage src={image} />
      <AvatarFallback>{getInitials(firstName, lastName)}</AvatarFallback>
    </Avatar>
  );
}
